import { useCallback } from 'react';
import {
  finishForm,
  resetFormData as resetFormDataAction,
  setFormError,
  startForm,
  updateFormData as updateFormDataAction,
} from 'js/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function useForms(formType: string) {
  const dispatch = useDispatch();

  const data = useSelector((state: any) => state.forms[formType]?.data);

  const updateFormData = useCallback(
    (formData) => {
      dispatch(updateFormDataAction(formType, formData));
    },
    [dispatch, formType],
  );

  const setError = useCallback(
    (error: string) => {
      dispatch(setFormError(formType, error));
    },
    [formType],
  );

  const start = useCallback(() => {
    dispatch(startForm(formType));
  }, [formType]);

  const end = useCallback(() => {
    dispatch(finishForm(formType));
  }, [formType]);

  const resetFormData = useCallback(
    (fields) => {
      dispatch(resetFormDataAction(formType, fields));
    },
    [dispatch, formType],
  );

  return {
    updateFormData,
    resetFormData,
    setError,
    start,
    end,
    data,
  };
}
